import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private _httpClient = inject(HttpClient);
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    private _router = inject(Router);
    private _authSvc = inject(AuthService);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) => {
                this._navigation.next(navigation);
            }),
        );
    }

    /**
     * Hijack logo navigation
     */
    hijackLogoNavigation(): void {
        if (this._authSvc.hasBasicRole('app_owner')) {
            this._router.navigate(['admin', 'projects']);

        } else if (this._authSvc.hasBasicRole('project_owner')) {
            this._router.navigate(['select', 'projects']);
        } else if (this._authSvc.hasBasicRole('company')) {
            this._router.navigate(['select', 'companies']);
        } else if (this._authSvc.hasBasicRole('site')) {
            this._router.navigate(['select', 'sites']);
        } else {
            this._router.navigate(['/']);
        }
    }
}
